import { useCallback, useRef } from 'react';
import { findDropTarget } from '../utils/dropTargetUtils';
import { syncDropTargetHighlight } from './dropTargetFeedback';

const DROP_TARGET_CHECK_MS = 80;

/**
 * Debounced nest-on-drop target detection during drag.
 * Uses a ref instead of state to avoid re-renders while dragging.
 */
export function useFlowchartDropTarget({
  tasks,
  nodePositions,
  customPositions,
  nodeDimensions,
  dropTargetRef,
}) {
  const lastDropCheckRef = useRef(0);

  const checkDropTarget = useCallback((draggedNodeId, cursorPosition, draggedIds) => {
    const now = Date.now();
    if (now - lastDropCheckRef.current < DROP_TARGET_CHECK_MS) return;
    lastDropCheckRef.current = now;

    const target = findDropTarget(
      draggedNodeId,
      cursorPosition,
      draggedIds,
      tasks,
      nodePositions,
      customPositions,
      nodeDimensions,
    );

    const prevTarget = dropTargetRef.current;
    dropTargetRef.current = target;
    syncDropTargetHighlight(prevTarget?.id, target?.id);
  }, [tasks, nodePositions, customPositions, nodeDimensions, dropTargetRef]);

  return { checkDropTarget };
}
